import React from "react";
import Loader from "@streeteasy/design-system/loader";

import * as S from "./styled";

const LoadingState = () => (
  <S.FullSizeContainer>
    <Loader labelText="Loading..." />
  </S.FullSizeContainer>
);

export default LoadingState;
